<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item md-size-50 mx-auto text-center">
        <h2 class="title">Categorías Capital</h2>
        <h5 class="description">
          Encuentra las categorías y visualiza los beneficios de aquellos que
          desbloquees.
        </h5>
      </div>
    </div>
    <modal v-if="smallAlertModal" @close="smallAlertModalHide()">
      <template slot="header">
        <h4 class="modal-title text-primary">
          Beneficios de ser
          {{ currentCategory.name }}
        </h4>
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="smallAlertModalHide"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <div
          v-for="benefit in currentCategory.categoryBenefits"
          :key="benefit.benefit.id"
        >
          <hr />
          <span
            class="text-info"
            v-if="benefit.benefit.type == 'percent_discount'"
            >{{ benefit.benefit.description }}: {{ benefit.value }}%</span
          >
          <span class="text-info" v-else
            >{{ benefit.benefit.description }}:
            {{ currencyValue(benefit.value) }}</span
          >
        </div>
      </template>

      <template slot="footer">
        <md-button class="md-simple" @click="smallAlertModalHide">Ok</md-button>
      </template>
    </modal>
    <div class="md-layout">
      <div
        v-for="category in categories"
        :key="category.id"
        :class="catClass()"
      >
        <pricing-card
          :card-class="catCardClass(category.id)"
          :icon-color="catIconColor(category.id)"
        >
          <h5 slot="category" class="category">
            {{ catCardScore(category.id) }}
          </h5>
          <md-icon slot="icon">{{ category.color }}</md-icon>
          <h3 slot="title" class="title">{{ category.name }}</h3>
          <md-button
            v-if="category.categoryBenefits.length"
            slot="description"
            @click="
              smallAlertModal = true;
              currentCategory = category;
            "
            :class="catFooterClass(category.id)"
            >Beneficios</md-button
          >
          <p
            v-for="benefit in category.categoryBenefits"
            :key="benefit.benefit.id"
            slot="description"
            class="card-description"
          >
            {{ benefit.benefit.description }}
          </p>
        </pricing-card>
      </div>
    </div>
  </div>
</template>
<script>
import { PricingCard, Modal } from "@/components";
import gql from "graphql-tag";
import Constants from "../../constants";
export default {
  components: {
    PricingCard,
    Modal
  },
  data() {
    return {
      categories: null,
      currentCategory: null,
      smallAlertModal: false,
      score: null,
      myCatId: null,
      Constants: Constants
    };
  },
  methods: {
    smallAlertModalHide: function() {
      this.smallAlertModal = false;
    },
    catClass() {
      var size = 100 / this.categories.length;
      return (
        "md-layout-item md-medium-size-" +
        size +
        " md-small-size-50 md-xsmall-size-100 md-size-" +
        size
      );
    },
    currencyValue(value) {
      return Constants.currencyValue(value);
    },
    catCardClass(id) {
      if (id != this.myCatId) return "md-card-plain";
      return "";
    },
    catCardScore(id) {
      if (id != this.myCatId) return "...";
      return this.score;
    },
    catIconColor(id) {
      if (id != this.myCatId) return "icon-white";
      return "icon-primary";
    },
    catFooterClass(id) {
      if (id != this.myCatId) return "md-white md-round";
      return "md-primary md-round";
    },
    showBenefits(category) {
      this.smallAlertModal = true;
      this.currentCategory = category;
    }
  },
  created() {
    this.$apollo
      .query({
        query: gql`
          query findAllCategories {
            findAllCategories {
              id: catId
              color: catColor
              name: catName
              categoryBenefits: capCategoryBenefits {
                value: categoryBenefitValue

                benefit: capBenefit {
                  id: benefitId
                  name: benefitName
                  description: benefitDescription
                  type: benefitType
                }
              }
            }
          }
        `
      })
      .then(data => {
        this.categories = data.data.findAllCategories;
      })
      .catch(error => {
        Constants.catchError(
          error,
          this.$apollo.provider.defaultClient,
          this,
          false
        );
      });
    this.$apollo
      .query({
        query: gql`
          query findScoreFromAccount($accountId: Int!) {
            findScoreFromAccount(accountId: $accountId) {
              accountId
              score
              categoryId
            }
          }
        `,
        variables: {
          accountId: Constants.getUserId()
        }
      })
      .then(data => {
        let scoreDTO = data.data.findScoreFromAccount;
        this.myCatId = scoreDTO.categoryId;
        this.score = scoreDTO.score;
      });
  }
};
</script>
<style scoped>
.text-center {
  text-align: center;
}
</style>
